import { Box, Flex } from '@chakra-ui/react';
import { useMultiStyleConfig } from '@chakra-ui/system';
import React from 'react';

interface SplitFeatureProps {
  colorScheme?: 'blue' | 'red';
  primaryContent: React.ReactElement;
  secondaryContent: React.ReactElement;
}

const SplitFeature: React.FC<SplitFeatureProps> = ({
  colorScheme = 'blue',
  primaryContent,
  secondaryContent,
}) => {
  const styles = useMultiStyleConfig('SplitFeature', { colorScheme });

  return (
    <Flex sx={styles.container}>
      <Box sx={styles.primaryFrame}>{primaryContent}</Box>
      <Box sx={styles.secondaryFrame}>{secondaryContent}</Box>
    </Flex>
  );
};

export default SplitFeature;
